export default __webpack_public_path__ + "static/media/MIT.4187dbc8.webp";